import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/data/content";

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("fr");
  const toggle = useCallback((l) => setLang(l), []);
  const t = translations[lang];
  return (
    <LangContext.Provider value={{ lang, setLang: toggle, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
